<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>
